import qs from 'qs';

interface InputUrlParams {
  transformationSignature: string;
  transformationName: string;
  transformationString: string;
  mediaType: string;
  assetSetId?: string;
  galleryMode?: string;
}

interface OutputUrlParams {
  transformationSignature: string;
  transformationName: string;
  transformationString: string;
  mediaType: string;
  assetSetId?: string;
  galleryMode?: 'grid' | 'spotlight';
}

const parseGalleryMode = (mode?: string): OutputUrlParams['galleryMode'] => {
  if (mode === 'grid' || mode === 'spotlight') {
    return mode;
  }
  return undefined;
};

export const useExtractTransformationsFromUrl = (): OutputUrlParams => {
  const { transformationSignature, transformationName, transformationString, mediaType, assetSetId, galleryMode } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  }) as unknown as InputUrlParams;

  return {
    transformationSignature,
    transformationName,
    transformationString,
    mediaType,
    assetSetId,
    galleryMode: parseGalleryMode(galleryMode),
  };
};
